<script lang="ts" setup>
import { Autoplay, Mousewheel } from 'swiper/modules'
import _shuffle from 'lodash-es/shuffle'
import betaniaImage from '@/assets/recommendations/kz-betania-katowice.webp'
import oazaImage from '@/assets/recommendations/oaza-wisla.webp'
import aniaWlochImage from '@/assets/recommendations/ania-wloch.webp'
import kasiaBartczakImage from '@/assets/recommendations/kasia-bartczak.webp'
import emiliaWlodkowskaImage from '@/assets/recommendations/emilia-wlodkowska.webp'
import aniaKenigImage from '@/assets/recommendations/ania-kenig.webp'
import weronikaGoryczkaImage from '@/assets/recommendations/weronika-goryczka.webp'
import mateuszCzyzImage from '@/assets/recommendations/mateusz-czyz.webp'
import kajaLapinskaImage from '@/assets/recommendations/kaja-lapinska.webp'
import brennaImage from '@/assets/recommendations/brenna.webp'

interface Recommendation {
  name: string
  image: string | undefined
  church: string
  location: string
  description: string
}

const recommendations: Recommendation[] = _shuffle([
  {
    name: 'Paulina',
    image: betaniaImage,
    church: 'Kościół Zielonoświątkowy "Betania" w Katowicach',
    location: 'Katowice',
    description: 'Korzystanie z CSM/online stało się niezwykle pomocne w rozwoju naszej grupy uwielbienia. Od teraz każdy muzyk i wokalista przygotowuje się indywidualnie, korzystając z tutoriali CSM, dzięki czemu na próbach zespołu skupiamy się nie na wymyślaniu aranżacji czy uczeniu poszczególnych partii, ale szlifowaniu szczegółów i zgraniu całego zespołu. Taka strategia bardzo usprawnia działanie całej grupy i pomaga nam usługiwać kościołowi podczas wielu wydarzeń.',
  },
  {
    name: 'Oaza Worship',
    image: oazaImage,
    church: 'Kościół Chrześcijan Baptystów "OAZA" w Wiśle',
    location: 'Wisła',
    description: 'Nasza grupa korzysta z materiałów CSM/online już od kilku lat, dzięki czemu jest lepiej zorganizowana. Zaoszczędziliśmy również sporo czasu. Zamiast szukać akordów do pieśni i porządkować własne materiały w różnych miejscach - teraz wszystko mamy w jednym systemie, do którego cały zespół ma łatwy dostęp. Dużym wsparciem są nagrania wideo z opracowanymi partiami dla poszczególnych instrumentów. Wszystko jest podane prosto i przejrzyście. Dziękujemy za waszą pracę!',
  },
  {
    name: 'Paulina',
    image: brennaImage,
    church: 'Kościół Chrześcijan Dnia Sobotniego',
    location: 'Brenna',
    description: 'Dużym atutem platformy jest jej funkcjonalność – możliwość ćwiczenia we własnym tempie oraz powrotu do bardziej wymagających fragmentów. Dzięki CSM/online widzimy, jak nasza grupa się rozwija, a to z kolei pozwala nam pomagać kościołowi wchodzić głębiej w modlitwę. Wykłady i nagrania z konferencji dostępne na platformie inspirują nas do rozwoju i pracy nad zespołem, a także pomagają poszerzać wiedzę z zakresu teologii uwielbienia.',
  },
  {
    name: 'Ania',
    image: aniaWlochImage,
    church: 'Kościół Jezusa Chrystusa w Krakowie',
    location: 'Kraków',
    description: 'Przez lata staraliśmy się ujednolicać nasze materiały, tworzyliśmy własne systemy, a nawet nagrywaliśmy głosy dla wokalistów. Zawsze jednak czegoś nam brakowało. Dzięki CSM/online sprawa stała się znacznie prostsza! Teraz mamy jedno źródło, w którym wszyscy mogą znaleźć to, czego potrzebują. Najbardziej jednak cenię to, że mogę uczyć się osób, które dbają nie tylko o „muzykę”, ale przede wszystkim o “serce” - aby płynące z niego nuty były czystym złotem, niosącym Bożą Obecność.',
  },
  {
    name: 'Mateusz',
    image: mateuszCzyzImage,
    church: 'Parafia Ewangelicko – Augsburska w Wiśle - Malince',
    location: 'Wisła - Malinka',
    description: 'W naszym kościele w służbę muzyczną zaangażowanych jest ponad 40 osób w różnym wieku i z różnym doświadczeniem. CSM/online oferuje bogaty repertuar pieśni - zarówno współczesnych jak i tych bardziej tradycyjnych, dzięki czemu łączy różne pokolenia. Lekcje wideo do nauki pieśni są profesjonalne i przystępne dla każdego, co wspiera rozwój naszej grupy i regularnie podnosi jej poziom. Zdecydowanie polecam!',
  },
  {
    name: 'Kasia',
    image: kasiaBartczakImage,
    church: 'Kościół Zielonoświątkowy "Dobra Nowina" w Głogowie',
    location: 'Głogów',
    description: 'Platforma CSM/online doskonale odpowiada na potrzeby grup uwielbienia w całej Polsce. Od kilku lat pomaga również nam w organizacji prób zespołu. Co ważne – dostępne materiały są zrozumiałe dla wszystkich, niezależnie od etapu rozwoju muzycznego. Szczególnie cenne jest to, że podczas przygotowań do uwielbienia mogę nie tylko posłuchać tutoriali z podziałem na głosy i instrumenty, ale także zaczerpnąć solidną dawkę inspiracji o tematyce uwielbienia. Szczerze polecam!',
  },
  {
    name: 'Emilia',
    image: emiliaWlodkowskaImage,
    church: 'Kościół Zielonoświątkowy "Radość" w Gdańsku',
    location: 'Gdańsk',
    description: 'W naszym kościele działa duża grupa uwielbienia, a składy zmieniają się rotacyjnie co niedzielę. Dlatego kluczowe jest dla nas korzystanie z jednolitych materiałów do nauki. Dzięki gotowym opracowaniom pieśni na CSM/online jest to możliwe. Oprócz tego rozwijamy analityczny słuch muzyczny i coraz lepiej rozumiemy swoje role w zespole. To rewelacyjne narzędzie do nauki repertuaru dla całej grupy i zdecydowanie przekłada się na jakość naszego usługiwania.',
  },
  {
    name: 'Ania',
    image: aniaKenigImage,
    church: 'Kościół Zielonoświątkowy "BETEL" w Ustroniu',
    location: 'Ustroń',
    description: 'Od wielu lat korzystamy w naszym kościele z platformy CSM/online, która realnie wspiera mnie w służbie lidera oraz funkcjonowaniu całego zespołu. Przygotowanie do prób i nabożeństw stało się znacznie bardziej uporządkowane i efektywne. Wszystko podane jest jak “na tacy”, dzięki czemu techniczna część próby jest znacznie krótsza, a my możemy poświęcić więcej czasu na wspólną modlitwę i szukanie prowadzenia Ducha Świętego. Dzięki CSM za wsparcie w pomnażaniu talentów dla Jego chwały!',
  },
  {
    name: 'Kaja',
    image: kajaLapinskaImage,
    church: 'Społeczność Chrześcijańska Północ w Warszawie',
    location: 'Warszawa',
    description: 'Dobre przygotowanie do uwielbienia od strony technicznej daje poczucie bezpieczeństwa i „wolności”, pozwalając skupić się na tym, co najważniejsze – modlitwie i uwielbieniu Trójjedynego Boga. Dlatego cieszymy się, że istnieje platforma CSM/online i korzystamy z niej od lat, szczególnie ceniąc opracowania głosów dla wokalistów oraz akordy do piosenek. Znajdują się tam również unikalne opracowania polskich pieśni uwielbienia, niedostępne nigdzie indziej.',
  },
  {
    name: 'Weronika',
    image: weronikaGoryczkaImage,
    church: 'Ewangeliczna Wspólnota Zielonoświątkowa w Wisłoczku',
    location: 'Wisłoczek',
    description: 'W platformie CSM/online szczególnie cenię jej ciągły rozwój. Regularnie dodawane są nowe pieśni – zarówno zagraniczne, jak i polskie, w tym autorskie kompozycje CSM/worship – co zapewnia aktualny i zróżnicowany repertuar. Nagrania wykładów i warsztatów pomagają spojrzeć szerzej na służbę uwielbienia, oferując realne wsparcie w budowaniu dojrzałej, zdrowej służby – zarówno pod względem muzycznym, organizacyjnym jak i duchowym.',
  },
])
</script>

<template>
  <v-container id="opinie">
    <div class="d-flex flex-column ga-5">
      <div class="mb-1 text-center">
        <v-chip
          color="gray-300"
          variant="outlined"
          text="Co mówią inni?"
        />
      </div>
      <div class="text-h3 text-center">
        Opinie
      </div>
      <div
        class="text-subtitle-1 text-gray-500 font-weight-regular mx-auto text-center"
        :style="{ maxWidth: '400px'}"
      >
        Zobacz jak CSM/online wspiera liderów uwielbienia w ich służbie.
      </div>
    </div>
  </v-container>
  <v-container fluid class="pa-0">
    <swiper
      slides-per-view="auto"
      :loop="true"
      :speed="1000"
      :modules="[
        Autoplay,
        Mousewheel,
      ]"
      :autoplay="{
        delay: 10000,
        disableOnInteraction: true,
      }"
      :mousewheel="{
        forceToAxis: true,
      }"
    >
      <swiper-slide
        v-for="(recommendation, index) in recommendations"
        :key="index"
        class="h-auto"
        :style="{ width: '400px' }"
      >
        <div class="px-3 fill-height" :style="{ boxSizing: 'border-box' }">
          <ui-recommendation
            class="h-100"
            :title="recommendation.name"
            :subtitle="recommendation.church"
            :description="recommendation.description"
            :avatar="recommendation.image"
            :color="index % 2 === 0 ? 'primary' : 'secondary'"
          />
        </div>
      </swiper-slide>
    </swiper>
  </v-container>
</template>
